module.exports = __webpack_public_path__ + "img/[翻白眼].7163bcca.svg";